module.exports = __webpack_public_path__ + "res/user_img.png";